/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable indent */
/* eslint-disable max-len */
import { isEqual } from "lodash";
import React, { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { useDispatch, useSelector } from "react-redux";
// eslint-disable-next-line import/no-extraneous-dependencies
// import { Slider } from "@mui/material";
import EditableConfigurationName from "../../../Common/components/EndPage/EditableConfigurationName/EditableConfigurationName";
import Spinner from "../../../Common/components/Icons/Spinner/Spinner";
import LabelsPicker from "../../../Common/components/Inputs/LabelsPicker/LabelsPicker/LabelsPicker";
import Navigator from "../../../Common/layouts/Navigator/Navigator";
import { selectConfigurationType, selectEventsData, updateConfiguration } from "../../../Common/store/slices/common";
import { logEvent, syncFiltersDependencies } from "../../../Common/utils/api/api";
import { tData } from "../../../Common/utils/translation/dataUtils";
import t from "../../../Common/utils/translation/translator";
import {
  selectApplicationSettingsChanged,
  selectConfigAxes,
  selectDriveSynchronizedFilters,
  selectFiltersInit,
  selectHighlightApplicationSettingsErrors,
  selectPossibleFiltersValues,
  selectRetrofitConfiguration,
  selectRetrofitSteps,
  setApplicationSettings,
  setApplicationSettingsChanged,
  setCurrentStep,
  setDriveSynchronizedFilters,
  setHighlightApplicationSettingsErrors,
  showSnackbar
} from "../../../Retrofit/store/slices/retrofit";
import SharedSurvey from "../../components/Survey/SharedSurvey";
import {
  formatConnectorType,
  formatDriveInterfaces,
  formatMotorEncoder,
  formatNbPhases,
  formatShaftEnd
} from "../../utils/func.util";

const ApplicationSettings = () => {
  const voltagesData = {
    "1 Phase": [100, 110, 120, 200, 220, 230, 240],
    "3 Phases": [200, 208, 220, 240, 380, 400, 480]
  };

  const dispatch = useDispatch();
  const steps = useSelector(selectRetrofitSteps);
  const configurationType = useSelector(selectConfigurationType);
  const configuration = useSelector(selectRetrofitConfiguration);
  const axes = useSelector(selectConfigAxes);
  const highlightErrors = useSelector(selectHighlightApplicationSettingsErrors);
  const applicationSettingsChanged = useSelector(selectApplicationSettingsChanged);
  const synchronizedDriveFilters = useSelector(selectDriveSynchronizedFilters);
  const possibleDriveFiltersValues = useSelector(selectPossibleFiltersValues)?.drive;
  const filtersInit = useSelector(selectFiltersInit);
  const eventsData = useSelector(selectEventsData);

  const [data, setData] = useState(configuration?.configData?.applicationSettings);
  const [initialFilters, setInitialFilters] = useState(null);
  const [syncronizedFilters, setSyncronizedFilters] = useState(JSON.parse(JSON.stringify(synchronizedDriveFilters)));
  const [firstOccurence, setFirstOccurence] = useState(true);
  const [loadingSetVoltage, setLoadingSetVoltage] = useState(false);
  const [selectedLabelsInit, setSelectedLabelsInit] = useState(
    Object.keys(voltagesData)?.reduce((acc, phase) => {
      if (data?.nbPhases?.includes(phase)) {
        acc[phase] = data?.driveVoltagesSplitted;
      }
      return acc;
    }, {})
  );
  const [currentPhaseBeingSelected, setCurrentPhaseBeingSelected] = useState(null);
  const [firstVisit, setFirstVisit] = useState(true);

  const {
    refetch: execSyncFilters,
    isFetching: isFetchingSyncFilters,
    isLoading: isLoadingSyncFilters
  } = useQuery(
    "SYNC_APPLICATION_SETTINGS_FILTERS",
    async () => {
      try {
        const motorFilters = filtersInit?.motorFilter;
        const driveFilters = filtersInit?.driveFilter;
        const gearboxFilters = filtersInit?.gearboxFilter;

        const motorEncoderFormatted = formatMotorEncoder(motorFilters?.motorEncoder);
        const shaftEndFormatted = formatShaftEnd(motorFilters?.shaftEnd);
        const connectorTypeFormatted = formatConnectorType(motorFilters?.connectorType);
        const nbPhasesFormatted = formatNbPhases(data?.nbPhases);

        const payload = {
          locale: window.msizerConfiguration?.locale || "en-WW",
          search: {
            applicationDataFilter: {
              withGearbox: motorFilters?.withGearbox,
              nominalTorqueOfMotor: motorFilters?.nominalTorque,
              nominalSpeedOfMotor: motorFilters?.nominalSpeed
            },
            driveFilter: {
              type: driveFilters?.driveType,
              communicationInterfaces: data?.driveInterface,
              outputCurrents: driveFilters?.outputCurrent,
              nominalPower: driveFilters?.nominalPower,
              switchingFreq: driveFilters?.switchingFreq,
              format: driveFilters?.format,
              nbPhases: nbPhasesFormatted,
              outputVoltages: data?.driveVoltages
            },
            motorFilter: {
              type: motorFilters?.motorType,
              feedbackType: motorEncoderFormatted,
              connectorType: connectorTypeFormatted,
              ipProtection: motorFilters?.ipDegreeOfProtection,
              holdingBrake: motorFilters?.holdingBrake,
              shaftEnd: shaftEndFormatted,
              length: motorFilters?.length,
              flangeSize: motorFilters?.flangeSize
            },
            gearboxFilter: {
              productOrComponentType: motorFilters?.withGearbox ? gearboxFilters?.productOrComponentType : undefined,
              reductionRatio: motorFilters?.withGearbox ? gearboxFilters?.ratio : undefined,
              torsionalBacklash: data?.withGearbox ? gearboxFilters?.torsionalBacklash : undefined,
              externalDiameter: motorFilters?.withGearbox ? gearboxFilters?.externalDiameter : undefined
            }
          }
        };

        const newFilters = await syncFiltersDependencies(configurationType, payload);
        const synchronizedFiltersCopy = newFilters?.drive;

        setSyncronizedFilters({
          ...synchronizedFiltersCopy
        });

        dispatch(
          setDriveSynchronizedFilters({
            ...synchronizedFiltersCopy
          })
        );

        return newFilters;
      } catch (error) {
        // dispatch(showMinimalPopup(`Filters dependencies error`));
        dispatch(showSnackbar({ id: "ERROR_FILTERS" }));
        logEvent(eventsData.locale, eventsData.types.errorFilters, eventsData.tags.none, configuration?.configId);

        console.error("ERR", error.response?.status);
      }
      return undefined;
    },
    {
      enabled: false
    }
  );

  const continueAction = () => {
    // if filters are not set, show a popup
    if (!data?.nbPhases?.length || !data?.driveVoltages?.length || !data?.driveInterface?.length) {
      dispatch(setHighlightApplicationSettingsErrors(true));
      return;
    }
    // if number of axes === 0, add an axis
    /*
    if (axes.length === 0) {
      dispatch(addNewAxis());
    }*/
    // applicationSettingsChanged is !firstVisit && !isEqual(initialFilters, data)
    if (applicationSettingsChanged) {
      dispatch(showSnackbar({ id: "APPLICATION_SETTINGS_CHANGED" }));
      dispatch(setApplicationSettingsChanged(false));
    }

    dispatch(setCurrentStep(steps.SPECIFY_SELECT));
    dispatch(updateConfiguration());
  };

  const groupedCommunicationInterfaceValues = (values) => {
    const groupedValues = [];
    if (!Array.isArray(values)) {
      return groupedValues; // Return an empty array if values is not valid
    }
    values.forEach((value) => {
      switch (value) {
        case "Modbus RTU":
        case "Modbus TCP":
        case "Modbus":
          groupedValues.push("Modbus");
          break;
        case "PTI":
        case "PTO":
        case "Digital I/O":
          groupedValues.push("Digital I/O");
          break;
        default:
          groupedValues.push(value);
      }
    });
    return [...new Set(groupedValues)];
  };

  const sortDriveVoltages = (driveVoltages) => {
    const ranges = [];
    const singleValues = [];

    // For each value check if it contains "..." if yes it get pushed to the "ranges" array, if not it get pushed to the "singleValues" array. Every NaN elements are removed.
    driveVoltages?.forEach((voltage) => {
      voltage = voltage.split(" V")[0];
      if (voltage.includes("...")) {
        const rangeValues = voltage
          .split("...")
          .map((part) => parseInt(part.trim(), 10))
          .filter((num) => !Number.isNaN(num));
        ranges.push(...rangeValues);
      } else {
        const num = parseInt(voltage.trim(), 10);
        if (!Number.isNaN(num)) {
          singleValues.push(num);
        }
      }
    });

    ranges.sort((a, b) => a - b);

    // Return an object with the min and max of the ranges array and the array of single values.
    return {
      min: ranges[0],
      max: ranges[ranges.length - 1],
      singleValues
    };
  };

  const handleSetVoltage = (voltageValue, phase) => {
    // console.log("handleSetVoltage", voltageValue, phase);
    const driveVoltage =
      // syncronizedFilters?.outputVoltages?.filter(
      possibleDriveFiltersValues?.driveVoltages?.filter((voltage) => {
        if (voltage.includes("...")) {
          const values = voltage.split("...").map((v) => parseInt(v, 10));
          return values[0] <= voltageValue[0] && voltageValue[0] <= values[1];
        }
        return parseInt(voltage, 10) === voltageValue[0];
      });

    // set the data only if it's different from the previous value
    const newData = {
      ...data,
      nbPhases: voltageValue?.length ? [phase] : [],
      driveVoltagesSplitted: voltageValue,
      driveVoltages: driveVoltage
    };

    if (JSON.stringify(newData) !== JSON.stringify(data)) {
      // console.log("handleSetVoltage", voltageValue, "=>", driveVoltage, phase);
      setData({
        ...data,
        nbPhases: voltageValue?.length ? [phase] : [],
        driveVoltagesSplitted: voltageValue,
        driveVoltages: driveVoltage
      });
    }

    const newSelectedLabelsInit = {
      [phase]: voltageValue
    };
    setSelectedLabelsInit(newSelectedLabelsInit);
    setTimeout(() => {
      setLoadingSetVoltage(false);
    }, 100);
  };

  const onSelectManually = (filterName) => {};

  // voltage filter as jsx element
  const voltageFilter = (
    <>
      <div className="m-1 md:m-0 space-x-1 ">
        <span className="text-sm font-semibold text-gray-600">{t("msizer.ui.app_settings.select_voltage")}</span>
        <span className="text-red-600 text-sm">*</span>
      </div>
      {Object.entries(voltagesData).map(([phase, values]) => (
        <div onClick={() => setCurrentPhaseBeingSelected(phase)}>
          <LabelsPicker
            idLabel={`voltage-${Array.from(phase)[0]}`}
            label={tData("drive", "nb_phases", phase)}
            singleChoice
            large
            cols={3}
            options={values?.map((voltage) => ({
              label: `${voltage} V`,
              key: voltage
            }))}
            onChange={(voltage) => {
              if (currentPhaseBeingSelected === phase) {
                setLoadingSetVoltage(true);
                handleSetVoltage(voltage, phase);
              }
            }}
            selectedLabelsInit={selectedLabelsInit[phase] || []}
            changeWithInit={loadingSetVoltage}
            disabledLabels={values?.filter((val) => {
              // Check if the value is a single value, if not check if it's out of range
              const sortedDriveVoltages = sortDriveVoltages(synchronizedDriveFilters?.driveVoltages || []);

              if (sortedDriveVoltages.singleValues?.includes(val)) return false;

              if (!sortedDriveVoltages.min && !sortedDriveVoltages.max) {
                return true;
              }

              return val < sortedDriveVoltages.min || val > sortedDriveVoltages.max || !syncronizedFilters;
            })}
            error={highlightErrors && !data?.driveVoltages?.length}
          />
        </div>
      ))}
    </>
  );

  const communicationInterfaceFilter = (
    <LabelsPicker
      idLabel="communication-interface"
      onSelectManually={() => onSelectManually("driveInterface")}
      singleChoice
      large
      label={t("msizer.ui.app_settings.select_communication")}
      largeLabel
      required
      cols={3}
      options={[
        ...groupedCommunicationInterfaceValues(formatDriveInterfaces(possibleDriveFiltersValues?.driveInterface) || [])
          .filter((d) => d !== null)
          ?.sort()
          .map((val) => ({
            label: tData("drive", "communication_interfaces", val),
            key: val
          }))
      ]}
      selectedLabelsInit={groupedCommunicationInterfaceValues(data?.driveInterface)}
      changeWithInit
      onChange={(type) => {
        const selectedValues = type.includes("Modbus")
          ? ["Modbus RTU", "Modbus TCP", "Modbus"]
          : type.includes("Digital I/O")
            ? ["PTI", "PTO", "Digital I/O"]
            : type;
        setData({
          ...data,
          driveInterface: selectedValues
        });
      }}
      // changeWithInit
      disabledLabels={[
        ...groupedCommunicationInterfaceValues(formatDriveInterfaces(possibleDriveFiltersValues?.driveInterface))
      ]?.filter(
        (val) =>
          ![
            ...groupedCommunicationInterfaceValues(formatDriveInterfaces(syncronizedFilters?.communicationInterfaces))
          ].includes(val)
      )}
      error={highlightErrors && !data?.driveInterface?.length}
    />
  );

  useEffect(() => {
    if (configuration?.configData?.applicationSettings) {
      setInitialFilters(configuration?.configData?.applicationSettings);
    }
    dispatch(setApplicationSettingsChanged(false));
  }, []);

  useEffect(() => {
    if (!firstOccurence) {
      dispatch(setApplicationSettingsChanged(!isEqual(initialFilters, data) && !firstVisit));
      dispatch(setApplicationSettings(data));
      dispatch(updateConfiguration());
    } else {
      setFirstOccurence(false);
    }
  }, [data]);

  useEffect(() => {
    execSyncFilters();
  }, [data, filtersInit]);

  useEffect(() => {
    dispatch(setHighlightApplicationSettingsErrors(false));
  }, []);

  useEffect(() => {
    if (configuration?.configData?.applicationSettings) {
      setFirstVisit(false);
    }
  }, []);

  return (
    <div>
      <div className="md:border-[1px] md:border-gray-100 md:shadow-lg md:p-4 md:rounded-sm md:border-solid">
        <EditableConfigurationName blue />
        <div className="relative">
          <div
            className={`bg-gray-50 backdrop-blur-xs bg-opacity-50 h-full w-full top-0 left-0 absolute flex items-center justify-center z-20 ${
              !(isFetchingSyncFilters || isLoadingSyncFilters) && "hidden"
            }`}
          >
            <Spinner id="loading_spinner" />
          </div>
          <div className="md:grid md:grid-cols-2 divide-y md:divide-y-0 divide-solid space-y-4 md:space-y-0 md:divide-gray-200 md:my-3">
            <div className="md:border-r-2 divide-y md:divide-y-0 space-y-4">
              <div className="md:flex-1 space-y-5 md:px-5">{voltageFilter}</div>
            </div>
            <div className="md:flex-1 space-y-5 md:px-5">{communicationInterfaceFilter}</div>
          </div>
        </div>
      </div>
      <Navigator
        continueButtonDisabled={
          !data?.nbPhases?.length || !data?.driveVoltages?.length || !data?.driveInterface?.length
        }
        continueAction={continueAction}
      />
      <SharedSurvey />
    </div>
  );
};

export default ApplicationSettings;
